import { Navigate } from 'react-router-dom';
import DashboardLayout from 'src/components/DashboardLayout';
import MainLayout from 'src/components/MainLayout';
import Account from 'src/pages/Account';
import CustomerList from 'src/pages/CustomerList/CustomerList';
import Dashboard from 'src/pages/Dashboard';
import Category from 'src/pages/Category/Category';
import Item from 'src/pages/Item/Item';
import Itemblock from 'src/pages/Itemblock/Itemblock';
import Userblock from 'src/pages/Userblock/Userblock';
import Login from 'src/pages/Login/Login';
import NotFound from 'src/pages/NotFound';
import ProductList from 'src/pages/ProductList/ProductList';
import Event from 'src/pages/Event/Event';
import Banner from 'src/pages/Banner/Banner';
import Register from 'src/pages/Register';
import Settings from 'src/pages/Settings';
import Report from 'src/pages/Report/Report';
import DeleteNFT from "./pages/Delete NFT/DeleteNFT";

const routes = [
  {
    path: "app",
    element: <DashboardLayout />,
    children: [
      { path: "account", element: <Account /> },
      { path: "customers", element: <CustomerList /> },
      { path: "dashboard", element: <Dashboard /> },
      { path: "category", element: <Category /> },
      { path: "item", element: <Item /> },
      { path: "itemblock", element: <Itemblock /> },
      { path: "userblock", element: <Userblock /> },
      { path: "products", element: <ProductList /> },
      { path: "event", element: <Event /> },
      { path: "banner", element: <Banner /> },
      { path: "settings", element: <Settings /> },
      { path: "report", element: <Report /> },
      { path: "deleteNFT", element: <DeleteNFT /> },
      { path: "*", element: <Navigate to="/404" /> },
    ],
  },
  {
    path: "/",
    element: <MainLayout />,
    children: [
      { path: "login", element: <Login /> },
      { path: "register", element: <Register /> },
      { path: "404", element: <NotFound /> },
      { path: "/", element: <Navigate to="/login" /> },
      { path: "*", element: <Navigate to="/404" /> },
    ],
  },
];

export default routes;
